import clsx from 'clsx'

const COLORS = [
  'bg-indigo-600', 'bg-emerald-600', 'bg-amber-600', 'bg-rose-600',
  'bg-sky-600', 'bg-violet-600', 'bg-teal-600', 'bg-orange-600',
  'bg-pink-600', 'bg-cyan-600', 'bg-lime-600', 'bg-fuchsia-600',
]

function hashName(name: string): number {
  let hash = 0
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash)
  }
  return Math.abs(hash)
}

interface AvatarProps {
  name: string
  size?: 'xs' | 'sm' | 'md' | 'lg'
  className?: string
}

const SIZES = {
  xs: 'h-5 w-5 text-[9px]',
  sm: 'h-6 w-6 text-[10px]',
  md: 'h-8 w-8 text-sm',
  lg: 'h-10 w-10 text-base',
}

export default function Avatar({ name, size = 'sm', className }: AvatarProps) {
  const words = name.trim().split(/\s+/)
  const initials = (words.length >= 2 ? words.map(w => w[0]).join('') : name.slice(0, 2)).toUpperCase()
  const color = COLORS[hashName(name) % COLORS.length]

  return (
    <span className={clsx('inline-flex shrink-0 items-center justify-center rounded-full font-semibold text-white', color, SIZES[size], className)}>
      {initials}
    </span>
  )
}
